exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".profile-completion-modal-container {\n  width: 70% !important;\n  height: 80% !important;\n}\n.profile-completion-modal-container .content {\n  height: 80% !important;\n}\n.profile-completion-modal-container .legalLinks_container {\n  text-align: end;\n}\n", ""]);

